// extracted by mini-css-extract-plugin
export default {"logoIcon":"options_logoIcon__Stp5J","textFieldRename":"options_textFieldRename__jJ0bq"};